import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import api from './request/api/index'
// import { Button, Select } from 'element-ui'
import { Container, Header, Aside, Main, Footer } from 'element-ui'
import { Row, Col, Menu, Submenu, MenuItemGroup, MenuItem} from 'element-ui'
import { Avatar } from 'element-ui'
import { Dropdown, DropdownMenu, DropdownItem } from 'element-ui'
import { Card } from 'element-ui'
import { Button } from 'element-ui'
import { Badge } from 'element-ui'
import { Upload } from 'element-ui'
import { Form } from 'element-ui'
import { FormItem } from 'element-ui'
import { Select } from 'element-ui'
import { OptionGroup } from 'element-ui'
import { Option } from 'element-ui'
import { DatePicker } from 'element-ui'
import { TimePicker } from 'element-ui'
import { Switch } from 'element-ui'
import { CheckboxGroup } from 'element-ui'
import { Checkbox } from 'element-ui'
import { RadioGroup } from 'element-ui'
import { Radio } from 'element-ui'
import { Input } from 'element-ui'
import { Alert } from 'element-ui'
import { Table } from 'element-ui'
import { TableColumn } from 'element-ui'
import { Pagination } from 'element-ui'
import { PageHeader } from 'element-ui'
import { Divider } from 'element-ui'
import { Loading } from 'element-ui'
// import { InputNumber } from 'element-ui'
// import { Popover } from 'element-ui'
import router from './router'

// Vue.use(Button)
// Vue.use(Select)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Row)
Vue.use(Col)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItemGroup)
Vue.use(MenuItem)
Vue.use(Avatar)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Card)
Vue.use(Button)
Vue.use(Badge)
Vue.use(Upload)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Select)
Vue.use(OptionGroup)
Vue.use(Option)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(Switch)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Input)
Vue.use(Alert)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(PageHeader)
Vue.use(Divider)
Vue.use(Loading)
// Vue.use(InputNumber)
// Vue.use(Popover)

Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.prototype.$api = api

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
